import RubricsPortfolioContext from '@/lib/contexts/RubricsPortfolioContext';
import { type RubricProofLink } from '@/lib/types';
import ensureLinkIsFullUrl from '@/lib/utils/ensureLinkIsFullUrl';
import { useContext } from 'react';

const DATE_LOWER_BOUND = new Date(0).toString();

const useProofLinks = (levelId: number): RubricProofLink[] => {
  const [portfolio] = useContext(RubricsPortfolioContext);

  const rawProofLinks = portfolio.proofLinks[levelId];

  if (typeof rawProofLinks === 'undefined') {
    return [];
  }

  return Object.entries(rawProofLinks).map(
    ([proofLinkId, proofLink]: [
      string,
      RubricProofLink | string,
    ]): RubricProofLink => {
      if (typeof proofLink === 'object') {
        return {
          ...proofLink,
          link: ensureLinkIsFullUrl(proofLink.link),
        };
      }

      return {
        id: parseInt(proofLinkId),
        link: ensureLinkIsFullUrl(proofLink),
        levelId,
        createdAt: DATE_LOWER_BOUND,
        updatedAt: DATE_LOWER_BOUND,
      };
    },
  );
};

export default useProofLinks;
